import React from 'react';
import { Attributes, Formatters, AttributeDetailRenderer, ValueText, DetailUtil as Util } from '@leverege/ui-attributes';
import { Flex, Popup } from '@leverege/ui-elements';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY = {};
export default class PositionDetailRenderer extends AttributeDetailRenderer {
  getLabelAndValue(object, cxt) {
    const attr = Attributes.getAttribute(this.name, object.type.replace('.history', ''));
    const label = this.detail?.label?.name || attr?.displayName || this.name || '';
    const value = attr == null ? null : attr.get(object.data, cxt);
    return [label, value];
  }
  getValueComponent(value, valueStyle, object, cxt, hasLabelComponent) {
    let disabled, formattedValue;
    if (typeof value?.lat === 'number' && typeof value?.lat === 'number') {
      formattedValue = Formatters.format(value, this.detail.formatter).join(',').trim();
      disabled = false;
    } else {
      formattedValue = value;
      disabled = true;
    }
    const onClick = () => {
      const lat = value?.lat;
      const lon = value?.lon;
      window.open(`https://www.google.com/maps/place/${lat},${lon}/@${lat},${lon}/data=!3m1!1e3`, '_blank');
    };
    if (disabled) {
      return /*#__PURE__*/_jsx(ValueText, {
        style: valueStyle,
        children: formattedValue
      });
    }

    // Treating it as an exceptional case since flex properties aren't being properly applied to the parent when the label is missing.
    if (!hasLabelComponent) {
      return /*#__PURE__*/_jsxs(Flex, {
        direction: "row",
        align: "center",
        justify: "space-between",
        style: {
          width: '100%',
          flexWrap: 'nowrap'
        },
        children: [/*#__PURE__*/_jsx(ValueText, {
          style: valueStyle,
          children: formattedValue
        }), /*#__PURE__*/_jsx(Popup, {
          toggleVariant: "positionDetailRenderer",
          children: /*#__PURE__*/_jsx(Popup.Item, {
            onClick: onClick,
            children: /*#__PURE__*/_jsx(ValueText, {
              variant: "positionDetailRenderer",
              children: "Open in Google Maps"
            })
          })
        })]
      });
    }
    return [/*#__PURE__*/_jsx(ValueText, {
      style: valueStyle,
      children: formattedValue
    }), /*#__PURE__*/_jsx(Popup, {
      toggleVariant: "positionDetailRenderer",
      children: /*#__PURE__*/_jsx(Popup.Item, {
        onClick: onClick,
        children: /*#__PURE__*/_jsx(ValueText, {
          variant: "positionDetailRenderer",
          children: "Open in Google Maps"
        })
      })
    })];
  }
  getComponents(object, cxt = EMPTY) {
    const {
      label: labelOpts = EMPTY,
      value: valueOpts = EMPTY,
      background
    } = this.detail;

    // eslint-disable-next-line prefer-const
    let [label, value] = this.getLabelAndValue(object, cxt);
    const hasValue = !(value == null || value.length === 0);
    if (!valueOpts.showIfEmpty && !hasValue) {
      return null;
    }
    if (!hasValue) {
      value = valueOpts.emptyValue;
    }
    const bg = Util.getBackground(background, object, cxt);
    const lps = Util.getParentStyle(labelOpts, bg, object, cxt);
    const vps = Util.getParentStyle(valueOpts, bg, object, cxt);
    const ls = Util.getStyle(labelOpts, object, cxt);
    const vs = Util.getStyle(valueOpts, object, cxt);
    const hasLabel = !(label == null || label.length === 0);
    const hasLabelComponent = labelOpts.visible === true && hasLabel;
    if (hasLabelComponent) {
      return [{
        component: this.getLabelComponent(label, ls, object, cxt),
        style: lps
      }, {
        component: this.getValueComponent(value, vs, object, cxt, hasLabelComponent),
        style: vps
      }];
    }
    return [{
      component: this.getValueComponent(value, vs, object, cxt, hasLabelComponent),
      style: vps
    }];
  }
}